import * as yup from "yup";

export const addParentSchema = yup.object({
    email: yup.string().email("* nieprawidłowy adres e-mail"),
});
